<template>
  <component
    :is="componentElement"
    v-bind="componentBinds"
    class="relative inline-flex flex-nowrap items-center justify-center gap-1 whitespace-nowrap rounded-lg py-3 px-4 text-center"
    @click="$emit('click')"
  >
    <svg
      v-if="loading"
      class="absolute -ml-1 h-5 w-5 animate-spin"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <span
      :class="{ invisible: loading && hideContentOnLoading }"
      class="inline-flex items-center justify-center gap-1 whitespace-nowrap"
    >
      <slot />
    </span>
  </component>
</template>
<script>
import ButtonLoading from './ButtonLoading.vue'
export default {
  name: 'AppButton',
  components: {
    ButtonLoading,
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'gray',
    },
    to: {
      type: [Object, String],
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hideContentOnLoading: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['click'],
  computed: {
    componentElement() {
      if (this.to) {
        return 'router-link'
      }

      if (this.href) {
        return 'a'
      }

      return 'button'
    },
    componentBinds() {
      if (this.to) {
        return {
          to: this.to,
        }
      }

      if (this.href) {
        return {
          href: this.href,
        }
      }

      return {}
    },
  },
}
</script>
